<ui-card
	class="[&>button]:hover:bg-gray-50 [&>button]:duration-300"
	[ngClass]="{ 'cursor-pointer': !(isOCRProcessing$ | async) }"
	(click)="clickHandler()"
>
	<button card-content *ngIf="!(isOCRProcessing$ | async); else showLoading">
		<div class="flex gap-4">
			<div
				class="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center"
			>
				<i-tabler name="file-text" class="text-blue-600 w-4 h-4" />
			</div>
			<div class="space-y-1 flex flex-col items-start">
				<h6 class="h6 mb-0">{{ _matterFile.name }}</h6>
				<p class="p-xs">Uploaded, {{ _matterFile.uploadedAt | closerDate }}</p>
			</div>
		</div>
	</button>
</ui-card>

<ng-template #showLoading>
	<app-ai-document-processing-progress-bar
		class="w-3/4"
		[matterDocumentType]="_matterDocumentType"
		messagePosition="start"
	></app-ai-document-processing-progress-bar>
</ng-template>
